<template>
    <div class="type">
        <template v-if="item.id==462">
            <div class="info" @click="gorule"></div>
            <div class="item" v-for="item in subItemList" :key="item.id" @click="goDetail(item)">
                <div class="title">
                    <div class="it">{{item.title}}</div>
                    <div class="cont">时间：{{item.start_time_show}} ～ {{item.end_time_show}}</div>
                </div>
                <img src="https://oss.mcloud.moveclub.cn/mcloud/jiading/arrow.png"  alt="">

            </div>
        </template>
        <template v-else-if="item.id==463">
            <div class="info2" @click="godraw">
                <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220830/1661862318/368107.png" @click.stop="godrawlu" alt="" >
            </div>
            <div class="item" v-for="item in subItemList" :key="item.id" @click="goDetail(item)">
                <div class="left">
                    <img :src="item.icon">
                </div>
                <div class="title2">
                    <div class="it">{{item.title}}</div>
                    <div class="cont">时间：{{item.start_time_show}} ～ {{item.end_time_show}}</div>
                </div>

            </div>
        </template>
        <template v-else-if="item.id==464">
            <div class="info3" @click="gorule"></div>
            <div class="list">
                <div class="item2" v-for="item in subItemList" :key="item.id" @click="goDetail(item)">
                    <div class="top">
                        <img :src="item.icon">
                    </div>
                    <div class="title">
                        <div class="it">{{item.title}}</div>
                    </div>

                </div>
            </div>
            
        </template>
        <div class="other"  v-if="subItemList.length == 0">
            <img style="width:3rem;height:3.54rem" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230615/1686813158/338324.png" alt="">
        </div>
        <van-dialog
            v-model="showRule"
            class="sports_item_rule_dialog rule"
            :show-confirm-button="false"
            message-align="left"
            close-on-click-overlay
            >
            <van-icon
                name="close"
                style="position:fixed;right:10px;"
                size=".4rem"
                @click="showRule=false"
            />
            <div
                class="rule"
            >
                <div
                :class="[item.id==462?'header':'header2']"
                slot="title"
                ></div>
                <div v-html="rule"></div>
                <div class="footer">
                    <Button
                    size="small"
                    round
                    type="warning"
                    block
                    @click="showRule=false"
                    color="#384883"
                >我已知晓</Button>
                </div>
                
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { Empty, Cell, CellGroup, Skeleton, Button, Image, Tag } from "vant";
import './index.less'
export default {
    components: {
        Empty,
        Cell,
        CellGroup,
        Skeleton,
        Button,
        VanImage: Image,
        Tag,
    },
    props: {
        item: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    watch: {
        item: {
            deep: true,
            handler(val) {
                this.getmain(val);
            },
        },
    },
    data() {
        return {
            showRule: false,
            subItemList: [],
            title: "",
            rule: "",
            enableActivity: false,
            scoreType: 1,
            content: "",
            canjoin: "",
        }
    },
    mounted() {
        // this.getmain(this.item)
    },
    methods: {
        getmain(item) {
            this.subItemList = [];
            this.rule = "";
            this.$api.sports.getItemSubs({ itemid: item.id }).then((res) => {
                this.subItemList = res.data.list;
                this.title = res.data.title;
                this.content = res.data.content;
                this.rule = res.data.rule;
                this.scoreType = res.data.score_type;
                this.canjoin = res.data.canjoin;
                if (+res.data.list.length === 1) {
                    let {
                        title,
                        start_time,
                        end_time,
                        vote_start_time,
                        vote_end_time,
                    } = res.data.list[0];
                    this.title = title;
                    this.enableActivity = res.sys_time > start_time;
                }
            });
            
        },
        goDetail(val) {
            if(val.register_type_value) {
                if(val.register_type_value.indexOf('https') != -1) {
                    window.location.href = val.register_type_value
                } else {
                    wx.miniProgram.navigateTo({
                        url:val.register_type_value
                    });
                }
                
                return
            }
            this.$router.push({name:'sportsDetail',params:{sports_id:val.sports_id,item_sub_id:val.id}})
        },
        godraw() {
            this.$router.push({name:'newanswer',params:{acid:1292}})
        },
        godrawlu() {
            this.$router.push({name:'luckdraw',params: {acid:1289}})
        },
        gorule() {
            this.showRule = true
        }
    }
}
</script>